export const TKeyContentCreation = {
  CONTENT_CREATION_NAV: "CONTENT_CREATION_NAV",
} as const;
